import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.5rem 0;

    h1 {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 1.5rem;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.tertiary_500};

      svg {
        width: 1.2rem;
        height: 1.2rem;
        fill: ${({ theme }) => theme.colors.tertiary_500};
      }
    }

    .close {
      padding: 0;
      height: 20px;

      button {
        color: #fff;
        background-color: ${({ theme }) => theme.colors.tertiary_500};
        width: 20px;
        height: 19px;
        border-radius: 100%;
        padding: 0;
        border: none;

        :hover {
          cursor: pointer;
        }
      }
    }
  }

  .containerAccounts {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-height: 25rem;
    overflow-y: auto;
    padding: 1rem;
  }

  p {
    color: #707070;
  }
`;
